module.exports = __webpack_public_path__ + "img/all.490a49ed.png";